'use client'

import { useEffect } from 'react'
import { X } from 'lucide-react'
import CommentThreadWrapper from '@/components/comments/CommentThreadWrapper'
import styles from '@/components/shorts/shorts.module.css'

interface ShortsCommentsPanelProps {
  newsId: number
  title: string
  open: boolean
  onClose: () => void
  onCountChange?: (count: number) => void
}

export default function ShortsCommentsPanel({
  newsId,
  title,
  open,
  onClose,
  onCountChange,
}: ShortsCommentsPanelProps) {
  useEffect(() => {
    if (!open) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [open])

  if (!open) return null

  return (
    <div
      className={styles.commentsBackdrop}
      role="presentation"
      data-shorts-control
      onPointerDown={(e) => e.stopPropagation()}
      onPointerUp={(e) => e.stopPropagation()}
      onClick={onClose}
    >
      <div
        className={styles.commentsSheet}
        role="dialog"
        aria-modal="true"
        aria-label={`${title} yorumları`}
        data-shorts-control
        onPointerDown={(e) => e.stopPropagation()}
        onPointerUp={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.commentsHeader}>
          <h3 className={styles.commentsTitle}>Yorumlar</h3>
          <button
            type="button"
            data-shorts-control
            className={styles.commentsClose}
            onClick={onClose}
            aria-label="Yorumları kapat"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className={styles.commentsBody} data-shorts-control>
          <CommentThreadWrapper
            targetType="article"
            targetId={newsId}
            onTotalCountChange={onCountChange}
          />
        </div>
      </div>
    </div>
  )
}
